import React from 'react'
import moment from 'moment'
import cx from 'classnames'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import CheckBoxView from 'components/ui/form/CheckBoxView/CheckBoxView'
import { Grid, Cell } from 'components/layout/grid'

import s from './WeekCheckBoxes.scss'


const WeekCheckBoxes = ({ className, dates, selectedDates, isWeekDaysOnly, isMobile, gutter, onChange }) => {
  return (
    <Grid className={cx(s.grid, className)} columns={dates.length} gutter={gutter}>
      {
        dates.map(({ day, weekDay, isExcluded, dateText }, index) => (
          <Cell key={index} size={1}>
            <Box pb="xs" alignCenter>
              <Text
                message={weekDay}
                size="sm"
              />
              {
                Boolean(!isWeekDaysOnly) && (
                  <Text
                    message={moment(day, 'YYYY.MM.DD').format('DD.MM')}
                    color="gray"
                    size={isMobile ? 'xs' : 'sm'}
                    tag="div"
                  />
                )
              }
            </Box>
            {
              isExcluded ? (
                <div />
              ) : (
                Boolean(selectedDates) && (
                  <CheckBoxView
                    className={s.checkBox}
                    isChecked={(
                      isWeekDaysOnly
                        ? selectedDates.includes(day)
                        : selectedDates.some((date) => (
                          date === moment(day, 'YYYY.MM.DD').format('DD.MM.YYYY')
                        ))
                    )}
                    onClick={() => onChange && onChange(
                      isWeekDaysOnly
                        ? day
                        : moment(day, 'YYYY.MM.DD').format('DD.MM.YYYY')
                    )}
                  />
                )
              )
            }
            {
              Boolean(dateText) && (
                <Text
                  message={dateText}
                  tag="div"
                  center
                />
              )
            }
          </Cell>
        ))
      }
    </Grid>
  )
}


export default WeekCheckBoxes
